module.exports = __webpack_public_path__ + "static/nulshock_el-webfont-987af68faf0543801381046cbc04577a.woff2";